const EntryService = require('../services/EntryService').default;
const getSpace = require('./contentful/get-space');
const transformer = require('./transformers/equipment');
const linkResolve = require('./contentful/link-resolve');
const processError = require('./contentful/error-process');

let entryService = null;

const gettingEntryService = () => {
  if (!entryService) {
    entryService = getSpace().then((space) => {
      return new EntryService(space, transformer);
    });
  }

  return entryService;
};

module.exports = {
  getById(...parameters) {
    return gettingEntryService().then((service) => service.getById(...parameters));
  },

  save(...parameters) {
    return gettingEntryService().then((service) => service.save(...parameters));
  },

  create(...parameters) {
    return gettingEntryService().then((service) => service.create('equipment', ...parameters));
  },

  publish(...parameters) {
    return gettingEntryService().then((service) => service.publish(...parameters));
  },

  unpublish(...parameters) {
    return gettingEntryService().then((service) => service.unpublish(...parameters));
  },

  archive(...parameters) {
    return gettingEntryService().then((service) => service.archive(...parameters));
  },

  unarchive(...parameters) {
    return gettingEntryService().then((service) => service.unarchive(...parameters));
  },

  initializeCustom(...parameters) {
    return gettingEntryService().then((service) => service.initializeCustom('equipment', ...parameters));
  },

  getAll(depth = 0) {
    return getSpace().then((space) => {
      return space.getEntries({
        content_type: 'equipment',
        order: 'fields.priority,-sys.updatedAt',
        limit: 999
      }).catch(
        processError
      ).then((response) => {
        const data = response.toPlainObject();
        return linkResolve(space, data, depth);
      }).then((data) => {
        return data.items.map(transformer.contentfulToInternal);
      });
    });
  },

  getByModelId(modelId, depth = 0) {
    if (!modelId) {
      throw new Error('Expected non-falsy model ID.');
    }

    return getSpace().then((space) => {
      return space.getEntries({
        'content_type': 'equipment',
        'fields.model.sys.id': modelId,
        'order': 'fields.priority,-sys.updatedAt'
      }).catch(
        processError
      ).then((entries) => {
        const data = entries.toPlainObject();
        return linkResolve(space, data, depth);
      }).then((data) => {
        return data.items.map(transformer.contentfulToInternal);
      });
    });
  },

  getLinkedEntries(entryId) {
    if (!entryId) {
      throw new Error('Expected non-falsy entry ID.');
    }

    return getSpace().then((space) => {
      return space.getEntries({
        links_to_entry: entryId
      }).catch(
        processError
      ).then((entries) => {
        const data = entries.toPlainObject();

        return data.items;
      });
    });
  }
};
